import { Component, Input, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { KnowledgeService } from '../../service/knowledge.service';
import { KnowledgeDetailComponent } from './knowledge-detail/knowledge-detail.component';
import * as moment from 'moment';
// import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-knowledge-manager',
  templateUrl: './knowledge-manager.component.html',
  styleUrls: ['./knowledge-manager.component.less']
})
export class KnowledgeManagerComponent implements OnInit {

  @Input() code: any; // code 0 备件只能查看，不能选择 code 1 备件可以查看 也可以被选中
  validateForm: FormGroup;
  knowledgeTypes = [];
  // listOfUser = [];
  // selectedValue: number;
  listOfData = [];
  // knowledgeName: string | null = null;
  startRow: number;
  // 分页查询条件
  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  private datePipe: DatePipe = new DatePipe('zh-cn');
  constructor(
    private fb: FormBuilder,
    private modal: NzModalService,
    public message: NzMessageService,
    private router: Router,
    private dataService: KnowledgeService
  ) {
    this.startRow = 1;
    this.pageIndex = 1;
    this.pageSize = 10;
  }

  ngOnInit(): void {
    // typeId: new FormControl({ value: this.typeId, disabled: true }, Validators.required),
    this.validateForm = this.fb.group({
      typeId: new FormControl({ value: null, disabled: false }),
      knowledgeName: new FormControl({ value: null, disabled: false })
    });
    this.initTypeData();
    this.queryKnowledgeData(1);
  }

  /**
   * 查询知识类型数据
   */
  async initTypeData() {
    const result = await this.dataService.queryKnowledgeType();
    if (result.code !== 200) {
      this.message.create('error', result.msg);
      return;
    }
    for (const data of result.data) {
      const node = {
        title: data.ktName,
        value: data.ktId,
        key: data.ktId
      };
      this.knowledgeTypes.push(node);
    }

  }
  /**
   * 查询知识库数据
   * @param flag  1表示点击搜索按钮，2表示翻页
   */


  async queryKnowledgeData(flag: number) {
    this.loading = true;
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    const result = await this.dataService.queryKnowledgeData(this.validateForm.value, this.pageIndex, this.pageSize);
    this.loading = false;
    if (result.code !== 200) {
      this.message.create('error', result.msg);
      return;
    }
    this.listOfData = result.data.list;
    this.listOfData.forEach(element => {
      element.createTime = this.formatDate(element.createTime);
      element.updateTime = this.formatDate(element.updateTime);
    });
    this.total = result.data.total;
    this.startRow = result.data.startRow;

  }

  submitForm() {
    this.queryKnowledgeData(1);
  }
  resetForm() {
    this.validateForm.setValue({ typeId: null, knowledgeName: null });
    this.queryKnowledgeData(1);
  }
  /**
   * 创建知识
   */
  createKnowledge() {
    const modals = this.modal.create({
      nzTitle: '创建-新知识',
      nzContent: KnowledgeDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 800,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        knowledgeTypes: this.knowledgeTypes,
        kno: null,
        info: null
      }
    });
    modals.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.resetForm();
            this.queryKnowledgeData(1);
          }
        }
      }
    );
  }
  onPageIndexChange(pageIndex): void {
    this.pageIndex = pageIndex;
    this.queryKnowledgeData(2);
  }
  /**
   * 格式化Date
   * @param date 日期
   */
  public formatDate(date: any): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
  }

  /**
   * 删除知识
   */
  async deleteData(kno: number) {
    this.modal.confirm({
      nzTitle: '<i>确认要删除该知识信息?</i>',
      nzOnOk: async () => {
        const result = await this.dataService.deleteKnowledge(kno);
        if (result.code !== 200) {
          this.message.create('error', '知识删除失败!');
        } else {
          this.message.create('success', '知识删除成功!');
          this.queryKnowledgeData(2);
        }
      }
    });
  }
  /**
   * 显示详情
   * @param flag 1表示修改，0表示查看详情
   */
  showDetail(flag: number, data: any) {
    let title = '【' + data.kname + '】详情';
    if (flag !== 0) {
      title = '【' + data.kname + '】修改';
    }
    const modals = this.modal.create({
      nzTitle: title,
      nzContent: KnowledgeDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 1000,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        knowledgeTypes: this.knowledgeTypes,
        kno: data.kno,
        info: data,
        canSave: (flag === 1) ? false : true
      }
    });
    modals.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.resetForm();
          }
        }
      }
    );
  }

  //导出知识列表
  async export() {

    this.loading = true;
  
    const result = await this.dataService.queryKnowledgeData(this.validateForm.value, 1, 5000);
    if (result.code !== 200) {
      this.message.create('error', result.msg);
      return;
    }

    let dataToExport: any[] = [];
    let listToExport = result.data.list;
    for (let j = 0; j < listToExport.length; j++) {

      const result = await this.dataService.queryKnowledgeAttachment(listToExport[j].kno);
      const fList = [];
      if (result.code === 200) {
        result.data.forEach(element => {
          fList.push(element.attachName);
        });
      } 

      let item = {
        "知识编号": listToExport[j].kno,
        "知识名称": listToExport[j].kname,
        "知识类型": listToExport[j].ktName,
        "责任人": listToExport[j].responser,
        "更新时间": moment(listToExport[j].updateTime).format('YYYY-MM-DD HH:mm:ss'),
        "描述": listToExport[j].desc,
        "附件": fList.join(",")
      };

      dataToExport.push(item);
    }

    this.loading = false;

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { '知识库': worksheet }, SheetNames: ['知识库'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });


    // FileSaver.saveAs(data, '知识库.xlsx');

  }

}
